import { send as fetch } from "httpie";

// Commons
const headers = {
  Accept: "application/json",
};

class RequestError extends Error {
  /**
   * Handle the different error states of the Httpie utility.
   * The Httpie send utility returns a promise that rejects on:
   *   timeout
   *   network error
   *   invalid json with application/json headers
   *   status codes >= 400
   * In these cases, we want an Error with an appropriate error message.
   * @url https://github.com/lukeed/httpie/blob/next/src/browser.js Httpie Browser
   * @param {XMLHttpRequest} req
   */
  static getErrorMessage(req) {
    if (req.type === "timeout") return "Network request timeout";
    // Generic network error.
    if (req.type === "error") return "Network request failed";
    // All other errors return Status code + status Message.
    return `${req.status} ${req.statusMessage}`;
  }

  constructor(req) {
    super(RequestError.getErrorMessage(req));
    this.error = req;
    this.status = req.status;
    this.statusMessage = req.statusMessage;
    this.data = req.data;
  }
}

export function send(method, pathname, body, opts = {}) {
  // format a canonical URL from base
  // ~> injects __API_DOMAIN__ value @ compile
  const url = new URL(pathname, __API_DOMAIN__);

  // accept custom headers, applying defaults
  opts.headers = { ...headers, ...opts.headers };

  if (body instanceof URLSearchParams) {
    opts.headers["content-type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";
    opts.body = body.toString(); //= > 'foo=123&foo=456&bar=hello%2Cworld'
  } else if (body != null) {
    opts.body = body; // let httpie deal w/ it
  }

  // equivalent of `fetch({ credentials: 'include' })` -> default: true
  opts.withCredentials = opts.withCredentials || opts.withCredentials == null;

  // httpie nests all data as `res.data` key
  // ~> prev fetch() instances only cared about `r.ok`
  return fetch(method, url, opts)
    .then(r => r.data)
    .catch(e => {
      throw new RequestError(e);
    });
}
